/* eslint-disable no-use-before-define */
import Autocomplete, { AutocompleteProps } from "@material-ui/lab/Autocomplete";
import { withStyles } from "@material-ui/core/styles";

const StyledAutocomplete = withStyles({
	inputRoot: {
		'&&[class*="MuiOutlinedInput-root"] $input': {
			padding: "7px 4px",
		},
		"&.Mui-focused fieldset": {
			borderWidth: "1px !important",
		},
		"&:hover fieldset": {
			borderColor: "#969392 !important",
		},
	},
	/**
	 * ⚠️ When using the `classes` prop with a `withStyles()`-wrapped Autocomplete,
	 * all class keys must be explicitly defined in `useStyles()` or they will trigger runtime errors.
	 * Only include keys that are supported by MUI Autocomplete (e.g., `option`, `groupLabel`, `inputRoot`, etc.).
	 *
	 * 🚫 Avoid using unsupported keys — it's not recognized by Autocomplete and will cause errors.
	 */
	option: {
		fontWeight: "normal",
	},
	groupLabel: {
		fontWeight: "normal",
	},
})(Autocomplete) as typeof Autocomplete;

interface Props {
	id: string;
	optionLabel: string;
}

export default function Complete<
	T,
	Multiple extends boolean | undefined = undefined,
	DisableClearable extends boolean | undefined = undefined,
	FreeSolo extends boolean | undefined = undefined
>(props: Props & AutocompleteProps<T, Multiple, DisableClearable, FreeSolo>) {
	const { options, optionLabel, ...other } = props;

	return <StyledAutocomplete getOptionLabel={(option) => (option as any)?.[optionLabel]} {...other} options={options || []} />;
}
